// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the MIT License.

import { registerServiceBusMessageFactory } from './servicebus/registerServiceBusMessageFactory';

registerServiceBusMessageFactory();

// Export types for customer consumption
export type { ServiceBusMessageContext } from '../types';
export type { IServiceBusMessageActions } from '../types/settlement-types';

// Export AMQP property encoding utilities
export { convertPropertiesToAmqpBytes, validateAmqpProperties } from './util/amqpPropertyEncoder';

// Export body parsing helper utilities
export { messageBodyAsJson, messageBodyAsText } from './util/messageBodyParser';
